module.exports = __webpack_public_path__ + "static/media/U1-T2-1-2.c5fd7957.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vo/U1-T2-1-2.mp3
// module id = 522
// module chunks = 0